import {spawnErrorToast} from '@hm/fundamental'
import type {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {useRefraQuery} from '@refra/modules/common/hooks'
import type {ErrorResponse} from '@refra/modules/common/types'
import {logger} from '@refra/modules/common/utils'

export const DEFAULT_REFRACTORIES_PAGE = 0
export const DEFAULT_REFRACTORIES_PAGE_LIMIT = 200

export const useRefractoriesQuery = ({
  page,
  limit,
  name,
  ids,
  manufacturerIds,
  activeAfter,
  enabled = true
}: {
  page?: number
  limit?: number
  name?: string
  ids?: number[]
  manufacturerIds?: number[]
  activeAfter?: string
  enabled?: boolean
}) => {
  const {t} = useTranslation()

  const defaultPage = page ?? DEFAULT_REFRACTORIES_PAGE
  const defaultLimit = limit ?? DEFAULT_REFRACTORIES_PAGE_LIMIT

  return useRefraQuery({
    queryKey: 'refractories',
    params: [{page: defaultPage, limit: defaultLimit, ids, name, manufacturerIds, activeAfter}],
    throwOnError: (error) => {
      const axiosError = error as AxiosError<ErrorResponse>
      const errorDetails =
        axiosError?.response?.data.detail ?? axiosError.message ?? axiosError.response?.status
      logger
        .context('useRefractoriesQuery')
        .extras({errorDetails})
        .error('Error occurred while fetching refractories data')

      spawnErrorToast(t('error.refractoriesQuery'))

      return false
    },
    enabled
  })
}
